import React, { Component } from 'react'
import { Link } from 'react-router';
import { translate } from "react-translate";

@translate("Barrio")
export default class Barrio extends Component {
  render () {
    const { title, img, id, t } = this.props;

    var style = {
      backgroundImage: 'url(' + img[0] + ')'
    }

    return (
    	<div style={style} className="img img-neighborhood">
        <div className="overlay-neighborhood">
          <h2>{title}</h2>
          <Link to={'barrios/' + id } className="visible-xs">
            {t("Ver_barrio")}
          </Link>
        </div>
    	</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/PageResidential/components/Neighborhood.component.js